export default __webpack_public_path__ + "static/IN-5907HD_Heater-Installation-a83180a5a4970e74f53285fc59174802.png";